import { IconBarcode, Stack } from '@vtex/admin-ui'
import { FormState } from '@vtex/admin-ui-form'
import { useSkus } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { DefaultProps } from 'typings'
import { MultiSelect } from '../../../MultiSelect'
import { DownloadButton } from '../DownloadButton'
import { ImportButton } from '../ImportButton'
import { SelectorHeader } from '../SelectorHeader'
import messages from './messages'
import { LIMITS } from 'shared'

interface SkuSelectorProps {
  name: string
  state?: FormState
  loading?: boolean
  placeholder?: string
  maxEntries?: number
}

function Header(props: DefaultProps) {
  const { children } = props

  const { $t } = useIntl()

  return (
    <SelectorHeader label={$t(messages.label)} Icon={IconBarcode}>
      {children}
    </SelectorHeader>
  )
}

function Selector(props: SkuSelectorProps) {
  const { name, state, placeholder, loading, maxEntries } = props

  const { formatMessage: i18n } = useIntl()

  const [searchTerm, setSearchTerm] = useState('')

  const { data: options, isLoading } = useSkus(searchTerm)

  return (
    <MultiSelect
      name={name}
      options={options?.items ?? []}
      label={placeholder ?? i18n(messages.placeholder)}
      loading={loading}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
      state={state}
      maxEntries={maxEntries ?? LIMITS.MAX_SKUS}
    />
  )
}

export function SkuSelector(props: DefaultProps) {
  return (
    <Stack space="$space-2" fluid>
      {props.children}
    </Stack>
  )
}

SkuSelector.Header = Header
SkuSelector.Download = DownloadButton
SkuSelector.Upload = ImportButton
SkuSelector.Selector = Selector
